export const MAIL_LAYOUT_WIDTH = 600;
export const MAIL_LAYOUT_WIDTH_PX = `${MAIL_LAYOUT_WIDTH}px`;
